
<template>
   <v-container fluid class="grey lighten-4" style="min-height: calc(100vh - 64px)">
      <v-container fluid>
         <v-row class="mb-4">
             <v-col cols="12" class="py-2 ">                
                
                <v-btn-toggle borderless mandatory background-color="transparent" style="overflow-x:auto;">                          
                    <v-btn value="-1" class="mr-4 rounded" color="grey lighten-2" small style="min-width:110px" @click.capture = "displayFilters('partymaster', 'manufacturer')">
                        PartyMaster - Manufacturer                         
                    </v-btn>                      
                    <v-btn value="1" class="mr-4 rounded" color="grey lighten-2" small style="min-width:110px" @click.capture = "displayFilters('partymaster', 'wholesaler')">
                        PartyMaster - Wholesaler                          
                    </v-btn>                
                    <v-btn value="0" class="mr-4 rounded" color="grey lighten-2" small style="min-width:110px" @click.capture = "displayFilters('productmaster', 'manufacturer')">
                        ProductMaster - Manufacturer                           
                    </v-btn>                                                                    
                    <v-btn value="2" class="rounded" color="grey lighten-2" small style="min-width:110px" @click.capture = "displayFilters('productmaster', 'marketing')">
                        ProductMaster - Marketing                           
                    </v-btn>                                                                    
                </v-btn-toggle>
            </v-col>
        </v-row>
         <v-data-table 
            :server-items-length="totalData"
            :footer-props="{'disable-items-per-page':true}"                                                            
            :options.sync="options"                                                             
            class="elevation-0 table"
            :headers="filters.master == 'partymaster' ? partyHeaders : productHeaders"
            :items="filters.master == 'partymaster' ? partyItems : productItems"
            style="background-color: transparent;"
            :loading="loading"> 

         <template v-slot:[`item.facility`]="{ item }">
            {{ item.facility ?  item.facility : '-'}}
         </template>
         <template v-slot:[`item.pack_type`]="{ item }">
            <div v-if="item.pack_type.length > 0">
               <v-chip-group active-class="primary--text" column >
                  <v-chip v-for="(tag, i) in item.pack_type" :key="i" small >
                     {{ tag.name }}
                  </v-chip>
               </v-chip-group>
            </div>
            <div v-else> - </div>
         </template>
         
         <template v-slot:[`item.dosage_form`]="{ item }">

            <div  v-if="filters.master == 'partymaster'">
               <div v-if="item.dosage_form.length > 0">
               <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="(tag, i) in item.dosage_form" :key="i" small>
                     {{ tag.name }}
                  </v-chip>
               </v-chip-group>
            </div>
            <div v-else> - </div>
            </div>
            <div v-else>
               {{ item.dosage_form ?  item.dosage_form : '-'}}
            </div>
         </template>
         <template v-slot:[`item.category`]="{ item }">
            <div  v-if="filters.master == 'partymaster'">
               <div v-if="item.category.length > 0">
                  <v-chip-group active-class="primary--text" column>
                     <v-chip v-for="(tag, i) in item.category" :key="i" small>
                        {{ tag.name }}
                     </v-chip>
                  </v-chip-group>
               </div>
               <div v-else> - </div>
            </div>
            <div v-else>
               {{ item.category ?  item.category : '-'}}
            </div>
         </template>

         <template v-slot:[`item.city`]="{ item }">
            <div v-if="item.city">{{ item.city.name }}</div>
            <div v-else> - </div>
            <!-- {{ item.city ?  item.city : '-'}} -->
         </template>

         <template v-slot:[`item.state`]="{ item }">
            <!-- {{ item.state ?  item.state : '-'}} -->
            <div v-if="item.state">{{ item.state.name }}</div>
            <div v-else> - </div>
         </template>

         <template v-slot:[`item.country`]="{ item }">
            {{ item.country ?  item.country : '-'}}
         </template>
         
         <template v-slot:[`item.packing`]="{ item }">
            {{ item.packing ?  item.packing : '-'}}
         </template>

         <template v-slot:[`item.certificate`]="{ item }">
            {{ item.certificate ?  item.certificate : '-'}}
         </template>

         <template v-slot:[`item.authorised`]="{ item }">
            <div v-if="item.authorised.length > 0">
               <v-chip-group active-class="primary--text" column>
                  <v-chip v-for="(tag, i) in item.authorised" :key="i" small >
                     {{ tag.name }}
                  </v-chip>
               </v-chip-group>
            </div>
            <div v-else> - </div>
         </template>

         <template v-slot:[`item.molecule`]="{ item }">
            <!-- {{ item.molecule ?  item.molecule : '-'}} -->
            <div v-if="item.molecule">{{ item.molecule.name }}</div>
            <div v-else> - </div>
         </template>

         <template v-slot:[`item.product_name`]="{ item }">
            {{ item.product_name ?  item.product_name : '-'}}
         </template>

         <template v-slot:[`item.product_strength`]="{ item }">
            <div  v-if="filters.master == 'productmaster'">
               <div v-if="item.product_strength.length > 0">
                  <v-chip-group active-class="primary--text" column>
                     <v-chip v-for="(tag, i) in item.product_strength" :key="i" small >
                        {{ tag.name }}
                     </v-chip>
                  </v-chip-group>
               </div>
               <div v-else> - </div>
            </div>
            <div v-else>
               {{ item.product_strength ?  item.product_strength : '-'}}
            </div>
         </template>

         <template v-slot:[`item.product_dosage_form`]="{ item }">
            <div  v-if="filters.master == 'productmaster'">
               <div v-if="item.product_dosage_form.length > 0">
                  <v-chip-group active-class="primary--text" column >
                     <v-chip v-for="(tag, i) in item.product_dosage_form" :key="i" small >
                        {{ tag.name }}
                     </v-chip>
                  </v-chip-group>
               </div>
               <div v-else> - </div>
            </div>
            <div v-else>
               {{ item.product_dosage_form ?  item.product_dosage_form : '-'}}
            </div>
         </template>

         <template v-slot:[`item.product_category`]="{ item }">
            <div  v-if="filters.master == 'productmaster'">
               <div v-if="item.product_category.length > 0">
                  <v-chip-group active-class="primary--text" column >
                     <v-chip v-for="(tag, i) in item.product_category" :key="i" small>
                        {{ tag.name }}
                     </v-chip>
                  </v-chip-group>
               </div>
               <div v-else> - </div>
            </div>
            <div v-else>
               {{ item.product_category ?  item.product_category : '-'}}
            </div>
         </template>

         <template v-slot:[`item.company`]="{ item }">
            <!-- {{ item.company ?  item.company : '-'}} -->
            <div v-if="item.company">{{ item.company.name }}</div>
            <div v-else> - </div>
         </template>

         <template v-slot:[`item.action`]="{ item }">
            <v-btn @click="showDetails(item)">OPEN</v-btn>
         </template>
            <template v-slot:top>
               <v-toolbar flat style="background-color: transparent;">
                  <div class="pa-0">
                     <v-chip-group active-class="primary--text" column>
                        <v-chip small v-for="chip in filteredChips" :key="chip">
                           {{ chip }}
                        </v-chip>
                     </v-chip-group>
                  </div>
               <v-spacer></v-spacer>
               <v-btn
                     color="primary"
                     dark                     
                     class="mr-2"
                     :disabled="!partyItems.length && !productItems.length"
                     @click="applyFilters(true)"
                     v-if="hasPermission('party-masters-create')"
                  >
                     Export
                  </v-btn>
               <v-dialog v-model="dialog" width="900">
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn
                     color="primary"
                     dark
                     v-bind="attrs"
                     v-on="on"
                  >
                     <v-icon >mdi mdi-filter-menu</v-icon>
                  </v-btn>
                  </template>

                  <v-card>
                  <v-card-title class="text-h5 py-2 grey lighten-2" >
                     Filter
                  </v-card-title>

                  <v-container fluid class="px-6" v-if="filters.master == 'partymaster' && filters.type">
                     <v-row>
                        <v-col class="d-flex" cols="12" sm="6" md="4">
                           <v-text-field
                              label="Name"
                              v-model="filters.partymaster.name"
                           ></v-text-field>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'manufacturer'">
                           
                           <v-autocomplete
                              v-model="filters.partymaster.facility"
                              :items="facilityItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Facility"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4" >
                           <v-select
                              :items="countries"
                              label="Country"
                              chips
                              deletable-chips
                              small-chips
                              v-model="filters.partymaster.country"
                           ></v-select>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4">
                           <!-- <v-text-field
                              v-model="filters.partymaster.state"
                              label="State"
                           ></v-text-field> -->
                           <v-autocomplete
                              v-model="filters.partymaster.state"
                              :items="stateItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="State"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4">
                           <!-- <v-text-field
                              v-model="filters.partymaster.city"
                              label="City"
                           ></v-text-field> -->
                           <v-autocomplete
                              v-model="filters.partymaster.city"
                              :items="cityItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="City"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <!-- <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'manufacturer'">
                           <v-text-field
                              v-model="filters.partymaster.packing"
                              label="Packing"
                           ></v-text-field>
                        </v-col> -->
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'manufacturer'">
                           
                           <v-autocomplete
                              v-model="filters.partymaster.packing"
                              :items="packingItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Packing"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'manufacturer'">
                           
                           <v-autocomplete
                              v-model="filters.partymaster.pack_type"
                              :items="packTypeItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Pack Type"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'manufacturer'">
                           <v-autocomplete
                              v-model="filters.partymaster.dosage_form"
                              :items="dosageFormItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Dosage Form"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'manufacturer'">
                           
                           <v-autocomplete
                              v-model="filters.partymaster.category"
                              :items="categoryItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Category"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <!-- <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'manufacturer'">
                           <v-text-field
                              v-model="filters.partymaster.certificate"
                              label="Certificate"
                           ></v-text-field>
                        </v-col> -->
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'manufacturer'">
                           
                           <v-autocomplete
                              v-model="filters.partymaster.certificate"
                              :items="certificateItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Certificate"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'wholesaler'">
                           
                           <v-autocomplete
                              v-model="filters.partymaster.authorised"
                              :items="authorisedItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Authorised"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                     </v-row>
                  </v-container>

                  <v-container fluid class="px-6" v-if="filters.master == 'productmaster' && filters.type">
                     <v-row>
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'marketing'">
                           <v-text-field
                              v-model="filters.productmaster.product_name"
                              label="Product Name"
                           ></v-text-field>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4">
                           <!-- <v-text-field
                              v-model="filters.productmaster.molecule"
                              label="Molecule"
                           ></v-text-field> -->
                           <v-autocomplete
                              v-model="filters.productmaster.molecule"
                              :items="moleculeItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Molecule"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4">
                           <v-autocomplete
                              v-model="filters.productmaster.product_strength"
                              :items="productStrengthItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Strength"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                           
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4">
                           
                           <v-autocomplete
                              v-model="filters.productmaster.product_dosage_form"
                              :items="productDosageFormItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Dosage Form"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'manufacturer'">
                           
                           <v-autocomplete
                              v-model="filters.productmaster.product_category"
                              :items="productCategoryItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Category"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" md="4" v-if="filters.type == 'marketing'">
                           <!-- <v-text-field
                              v-model="filters.productmaster.company"
                              label="Company"
                           ></v-text-field> -->
                           <v-autocomplete
                              v-model="filters.productmaster.company"
                              :items="companyItems"
                              item-text="name"
                              item-value="name"
                              chips
                              deletable-chips
                              small-chips
                              label="Company"
                              hide-selected
                              hide-no-data
                           ></v-autocomplete>
                        </v-col>
                     </v-row>
                  </v-container>

                  <v-card-actions v-if="filters.master && filters.type">
                     <v-spacer></v-spacer>
                     <v-btn color="primary" @click="applyFilters()"  :disabled="isBtnDisabled() || subBtn.loading" :loading="subBtn.loading">
                        Filter
                     </v-btn>
                  </v-card-actions>
                  </v-card>
               </v-dialog>
               </v-toolbar>
            </template>
           
         </v-data-table>
      </v-container>
   </v-container>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      loading: true,
      totalData: 0, 
      subBtn: {
         loading:false,
      },
      countries: [ "Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas (the)", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic (the)", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros (the)", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti", "Dominica", "Dominican Republic (the)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia (the)", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (the)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands (the)", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia (Federated States of)", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands (the)", "New Caledonia", "New Zealand", "Nicaragua", "Niger (the)", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines (the)", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of North Macedonia", "Romania", "Russian Federation (the)", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan (the)", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan (Province of China)", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates (the)", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "United States of America (the)", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe" ],
      filteredChips: [],
      options:{
         itemsPerPage: 15,
         page: 1
      },
      partyHeaders: [
         { text: 'Party Name', align: 'start', sortable: false, value: 'name', type: ''},
         { text: 'City', align: 'start', sortable: false, value: 'city', type: ''},
         { text: 'State', align: 'start', sortable: false, value: 'state', type: ''},
         { text: 'Country', align: 'start', sortable: false, value: 'country', type: ''},
         { text: "", sortable: false, value: "action" }
      ],

      productHeaders: [
         { text: 'Product Name', align: 'start', sortable: false, value: 'product_name', },
         { text: 'Molecule', sortable: false, value: 'molecule', },
         { text: 'Strength', sortable: false, value: 'product_strength', },
         { text: 'Dosage Form', sortable: false, value: 'product_dosage_form', },
         { text: 'Company', sortable: false, value: 'company', },
         { text: 'Category', sortable: false, value: 'product_category', },
         { text: "", sortable: false, value: "action" }
      ],
      
      masterItems:[
         {
            key:'partymaster',
            display: 'Party Master'
         },
         {
            key:'productmaster',
            display: 'Product Master'
         }
      ],
      masterTypes: {
         PartyMaster: [
            {
               key:'manufacturer',
               display: 'Manufacturer'
            },
            {
               key:'wholesaler',
               display: 'Wholesaler'
            }
         ],
         ProductMaster: [
            {
               key:'marketing',
               display: 'Marketing'
            },
            {
               key:'manufacturer',
               display: 'Manufacturer'
            }
         ]
      },

      packTypeItems: [],
      dosageFormItems: [],
      categoryItems: [],
      authorisedItems: [],
      packingItems: [],
      certificateItems: [],
      facilityItems: [],
      stateItems: [],
      cityItems: [],

      moleculeItems: [],
      productStrengthItems: [],
      productDosageFormItems: [],
      productCategoryItems: [],
      companyItems: [],

      filters:{
         master: 'partymaster',
         type: 'manufacturer',
         partymaster:{
            name:"",
            facility:[],
            pack_type: [],
            dosage_form: [],
            category:[],
            packing:[],
            certificate:[],
            authorised:[],
            city: "",
            state: "",
            country: ""
         },
         productmaster:{
            product_name:"",
            molecule:"",
            product_strength:[],
            product_dosage_form:[],
            company: "",
            product_category:[]
         }
      },

      partyItems: [],
      productItems: []
      
    }),

    methods: {
      convertToArray(val){
         if(val == null || val == "")
            return []
         else{
            var arr = Array.isArray(val) ? val : Array.of(val)
            return arr
         }
      },
      applyFilters(is_export = false) {
         this.subBtn.loading = true;
         this.loading = true
         let filterObj = ""

         if(!is_export) {
            this.productItems = []
            this.partyItems = []
         }
         


         if(this.filters.master === 'partymaster') {
            var facility_arr = this.convertToArray(this.filters.partymaster.facility)
            var pack_type_arr = this.convertToArray(this.filters.partymaster.pack_type)
            var dosage_form_arr = this.convertToArray(this.filters.partymaster.dosage_form)
            var category_arr = this.convertToArray(this.filters.partymaster.category)
            var packing_arr = this.convertToArray(this.filters.partymaster.packing)
            var certificate_arr = this.convertToArray(this.filters.partymaster.certificate)
            var authorised_arr = this.convertToArray(this.filters.partymaster.authorised)

            filterObj = {
               "master": this.filters.master,
               "type" : this.filters.type, 
               "export":is_export,
               "partymaster":{
                  "name": this.filters.partymaster.name,
                  "pack_type": pack_type_arr,
                  "facility": facility_arr,
                  "dosage_form": dosage_form_arr,
                  "category": category_arr,
                  "packing": packing_arr,
                  "certificate": certificate_arr,
                  "authorised": authorised_arr,
                  "city": this.filters.partymaster.city,
                  "state": this.filters.partymaster.state,
                  "country": this.filters.partymaster.country,
               }
            }

            this.partymasterFilteredChipArr()
            
         } else {
            var strength_arr = this.convertToArray(this.filters.productmaster.product_strength)
            var product_dosage_form_arr = this.convertToArray( this.filters.productmaster.product_dosage_form)
            var product_category_arr = this.convertToArray(this.filters.productmaster.product_category)

            filterObj = {
               "master": this.filters.master,
               "type" : this.filters.type, 
               "export":is_export,
               "productmaster": {
                  "product_name": this.filters.productmaster.product_name,
                  "molecule": this.filters.productmaster.molecule,
                  "strength": strength_arr,
                  "dosage_form": product_dosage_form_arr,
                  "company": this.filters.productmaster.company,
                  "category": product_category_arr
               }
            }

            this.productmasterFilteredChipArr()
         }

         Vue.axios.post(`api/filter?page=${this.options.page}`, filterObj)
            .then((res) => {
               this.loading = false
               // this.totalData = res.data.data.total
               // console.log("is_export")
               // console.log(is_export)
                              
               if(is_export){
                  window.open(`${process.env.VUE_APP_API_URL}/storage/${res.data.file_path}`)
               }
               else{
                  // console.log(res);
                  // if(res.data.data) {
                     const data = res.data.data.data
                     this.totalData = res.data.data.total
                     this.filters.master === 'partymaster' ? this.partyItems = data : this.productItems = data
                  // }
               }
               
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
               this.subBtn.loading = false;
               this.dialog = false
               this.loading = false
            })
      },

      showDetails(obj) {
         if(this.filters.master == 'partymaster') {
            window.open("/masterDetails/" + obj.id, '_blank', 'noreferrer');
         } else {
            window.open("/productDetails/" + obj.id, '_blank', 'noreferrer');
         }
      },

      isBtnDisabled() {
         return !this.filters.master || !this.filters.type
      },

      getFacility() {
         Vue.axios.post(`/api/search`, {
            modal : "Facility"
         })
         .then((res) => {
            const data = res.data.data
            this.facilityItems = data
         })
      },

      getState() {
         Vue.axios.post(`/api/search`, {
            modal : "State"
         })
         .then((res) => {
            const data = res.data.data
            this.stateItems = data
         })
      },

      getCity() {
         Vue.axios.post(`/api/search`, {
            modal : "City"
         })
         .then((res) => {
            const data = res.data.data
            this.cityItems = data
         })
      },

      getPackType() {
         Vue.axios.post(`/api/search`, {
            modal : "PackType"
         })
         .then((res) => {
            const data = res.data.data
            this.packTypeItems = data
         })
      },

      getDosageForm() {
         Vue.axios.post(`/api/search`, {
            modal : "DosageForm"
         })
         .then((res) => {
            const data = res.data.data
            this.dosageFormItems = data
         })
      },

      getCategory() {
         Vue.axios.post(`/api/search`, {
            modal : "Category"
         })
         .then((res) => {
            const data = res.data.data
            this.categoryItems = data
         })
      },

      getAuthorised(){
         Vue.axios.post(`/api/search`, {
            modal : "Authorised"
         })
         .then((res) => {
            const data = res.data.data
            this.authorisedItems = data
         })
      },

      getMolecule() {
         Vue.axios.post(`/api/search`, {
            modal : "Molecule"
         })
         .then((res) => {
            const data = res.data.data
            this.moleculeItems = data
         })
      },

      getProductStrength() {
         Vue.axios.post(`/api/search`, {
            modal : "ProductStrength"
         })
         .then((res) => {
            const data = res.data.data
            this.productStrengthItems = data
         })
      },

      getProductDosageForm() {
         Vue.axios.post(`/api/search`, {
            modal : "ProductDosageForm"
         })
         .then((res) => {
            const data = res.data.data
            this.productDosageFormItems = data
         })
      },

      getProductCategory() {
         Vue.axios.post(`/api/search`, {
            modal : "ProductCategory"
         })
         .then((res) => {
            const data = res.data.data
            this.productCategoryItems = data
         })
      },

      getCompany() {
         Vue.axios.post(`/api/search`, {
            modal : "Company"
         })
         .then((res) => {
            const data = res.data.data
            this.companyItems = data
         })
      },

      getPacking() {
         Vue.axios.post(`/api/search`, {
            modal : "Packing"
         })
         .then((res) => {
            const data = res.data.data
            this.packingItems = data
         })
      },

      getCertificate() {
         Vue.axios.post(`/api/search`, {
            modal : "Certificate"
         })
         .then((res) => {
            const data = res.data.data
            this.certificateItems = data
         })
      },

      displayFilters( master, type ) {
         this.resetFilters()
         this.filters.master = master 
         this.filters.type = type
         this.options.page = 1
         this.applyFilters()
         
      },

      resetFilters() {
         this.filters.partymaster.name = "",
         this.filters.partymaster.facility = [],
         this.filters.partymaster.pack_type =  [],
         this.filters.partymaster.dosage_form =  [],
         this.filters.partymaster.category = [],
         this.filters.partymaster.packing = [],
         this.filters.partymaster.certificate = [],
         this.filters.partymaster.authorised = [],
         this.filters.partymaster.city =  "",
         this.filters.partymaster.state =  "",
         this.filters.partymaster.country =  "",

         this.filters.productmaster.product_name = "",
         this.filters.productmaster.molecule = "",
         this.filters.productmaster.product_strength = [],
         this.filters.productmaster.product_dosage_form = [],
         this.filters.productmaster.company = "",
         this.filters.productmaster.product_category = []
      },

      pushToFilteredArr(item) {
         if(!item || item.length === 0) {
            return
         } else {
            this.filteredChips.push(item)
         } 
      },

      partymasterFilteredChipArr(){
         this.filteredChips = []

         this.pushToFilteredArr(this.filters.partymaster.name )
         this.pushToFilteredArr(this.filters.partymaster.facility )
         this.pushToFilteredArr(this.filters.partymaster.country )
         this.pushToFilteredArr(this.filters.partymaster.state )
         this.pushToFilteredArr(this.filters.partymaster.city )
         this.pushToFilteredArr(this.filters.partymaster.packing )
         this.pushToFilteredArr(this.filters.partymaster.pack_type )
         this.pushToFilteredArr(this.filters.partymaster.dosage_form )
         this.pushToFilteredArr(this.filters.partymaster.category )
         this.pushToFilteredArr(this.filters.partymaster.certificate )
         this.pushToFilteredArr(this.filters.partymaster.authorised )
      },

      productmasterFilteredChipArr() {
         this.filteredChips = []

         this.pushToFilteredArr(this.filters.productmaster.product_name )
         this.pushToFilteredArr(this.filters.productmaster.molecule )
         this.pushToFilteredArr(this.filters.productmaster.product_strength )
         this.pushToFilteredArr(this.filters.productmaster.product_dosage_form )
         this.pushToFilteredArr(this.filters.productmaster.company )
         this.pushToFilteredArr(this.filters.productmaster.product_category )
      }
   
    },

    mounted(){
       this.applyFilters()

       this.getFacility()
       this.getState()
       this.getCity()
       this.getPackType()
       this.getDosageForm()
       this.getCategory()
       this.getPacking()
       this.getCertificate()
       this.getAuthorised()
       
       this.getMolecule()
       this.getProductStrength()
       this.getProductDosageForm()
       this.getProductCategory()
       this.getCompany()
   },

   watch:{
      
      // "filters.master": {
      //    handler: function () {                        
      //       this.filters.type = ''
      //    },
         
      // }

      options: {
        handler () {
            this.applyFilters()
        },
        deep: true,
      },
   }

   
  }
</script>

<style scoped>
    .v-data-table >>> .v-data-table__wrapper,
    .v-data-table >>> .v-data-footer {
        background-color: #fff;
    }

    .table >>> .v-toolbar__content{
        padding-inline: 0;
    }

    .filter-btns-container{
      border-bottom: 1px solid #000;
    }
</style>